import React from 'react';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { IconButton, Stack, Tooltip } from '@mui/material';

import { NumericField } from '@paragon/material';

import {
  decrementBasicInsertionPlurality,
  incrementBasicInsertionPlurality,
} from '../../../store/actions/insertActions';
import { getBasicInsertionInformation } from '../../../store/selectors/basicInsertionSelectors';
import {
  BasicInsertionSettings,
  LineSelection,
  setBasicInsertionPlurality,
} from '../../../store/slices/applicationSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { StandardFloatingBox } from './common/StandardFloatingBox';

export function BasicInsertionSettingsFloatingBox() {
  const insertionInformation = useAppSelector(getBasicInsertionInformation);

  return insertionInformation.inserting && insertionInformation.definition.firstSelection?.type === 'line' ? (
    <BasicInsertionLineSnappingFloatingBox
      baseLine={insertionInformation.definition.firstSelection}
      settings={insertionInformation.definition.settings}
    />
  ) : null;
}

export function BasicInsertionLineSnappingFloatingBox(props: {
  baseLine: LineSelection;
  settings: BasicInsertionSettings;
}) {
  const dispatch = useAppDispatch();

  const plurality = props.settings.plurality;

  return (
    <StandardFloatingBox>
      <Tooltip title="only supported for division lines">
        <Stack direction="row" sx={{ alignItems: 'center' }} spacing={1}>
          <NumericField
            integers
            sx={{ width: '6em' }}
            label="Quantity"
            value={plurality}
            onSubmit={(value) => {
              dispatch(setBasicInsertionPlurality(value));
            }}
          />

          <IconButton size="small" onClick={() => void dispatch(incrementBasicInsertionPlurality())}>
            <AddCircleIcon />
          </IconButton>

          <IconButton size="small" onClick={() => void dispatch(decrementBasicInsertionPlurality())}>
            <RemoveCircleIcon />
          </IconButton>
        </Stack>
      </Tooltip>
    </StandardFloatingBox>
  );
}
